import { React,useState,useContext,useEffect } from 'react'
import { FaEdit } from "react-icons/fa";
import { Col, Row, FormGroup, Label, Input, Form, Table, NavLink } from 'reactstrap';
import SubHeader from './SubHeader';
import { GlobalContext } from '../../App';
import TopHeader from './TopHeader';
import { BsChevronRight } from "react-icons/bs";
import { toast } from 'react-toastify';
import axios from '../../api/axios';
import { InfinitySpin } from "react-loader-spinner";
import { useNavigate, useLocation } from "react-router-dom";
function AddCompany() {
    const navigate = useNavigate();
    const location = useLocation();
    const { pathname } = location;
    const [modal, setModal] = useState(false);
    const [isFilter, setIsFilter] = useState(false);
    const [companyName, setCompanyName] = useState("");
    const [companyDesc, setCompanyDesc] = useState("");
    const [isActive,setIsActive] = useState("1");
    const { rolexModuleData,roles,user_id} = useContext(GlobalContext);
    const [companyData, setCompanyData] = useState("");
    const [updateId, setUpdateId] = useState("");
    const [loading, setLoading] = useState(true); 
     // Handle Error
  const handleError = (error) => {
    setLoading(false);
    const statusCode = error.response ? error.response.status : null;
    let errorMessage = "An error occurred!";

    if (statusCode === 500) {
      errorMessage = "Internal Server Error!";
    } else if (statusCode === 404) {
      errorMessage = "Page Not Found!";
    }

    toast.error(errorMessage, {
      position: toast.POSITION.TOP_RIGHT,
      theme: "colored",
      autoClose: 2000,
    });
  };
    // ----------------------------------------------------------- Handle Close ---------------------------------------
  const handleClose = () => {
    setModal(false);
    setIsFilter(false);
    setCompanyName('');
    setCompanyDesc('');
    setUpdateId('');
    setIsActive('1');
}
// Modal State Change
  const toggleModal = () => {
    setIsFilter(false);
    setModal(!modal);
  }
// Filter Data
  const toggleFilter = () => {
    setIsFilter(true);
    setModal(!modal);

  }
// Post Company Data
  const postCompanyData = (e) => {
    e.preventDefault();
        if (companyName === null || companyName === "") {
            toast.error("Company Name is required!", {
                position: toast.POSITION.TOP_RIGHT,
                theme: "colored",
                autoClose: 2000
            });
        }
        else if (companyDesc === null || companyDesc === "") {
            toast.error("Company Description is required!", {
                position: toast.POSITION.TOP_RIGHT,
                theme: "colored",
                autoClose: 2000
            });
        }
        else {
            const params = {
                companyName : companyName,
                companyDesc : companyDesc,
                isActive : isActive,
                user_id: user_id,
                updateId: updateId 
            }
            axios.post('/postCompanyData', params).then((response)=>{
                if(response?.status === 202){
                    toast.error("Company Name Already Exist!", {
                        position: toast.POSITION.TOP_RIGHT,
                        theme: "colored",
                        autoClose: 2000
                    });
                }
                else{
                    toast.success("Company Insert/Updated Successfully!", {
                        position: toast.POSITION.TOP_RIGHT,
                        theme: "colored",
                        autoClose: 2000
                    });
                    handleClose();
                    getCompBuDeptData();
                }
            }
            ).catch(handleError);
        }
}
// get Company Data
const getCompBuDeptData =  () => {
    setLoading(true);
    axios.get('/getCompBuDeptData').then((response)=>{ 
        setCompanyData(response?.data?.[0]?.company_data);   
        setLoading(false);     
      }).catch(handleError);
}
// Company Update
const companyUpt = (company_id) => {
    companyData?.filter((data)=> data?.company_id === company_id)?.map((data)=>(
        setCompanyName(data?.company_name),
        setCompanyDesc(data?.company_description),
        setIsActive(data?.isActive),
        setUpdateId(company_id)
    ));
    setModal(true);    
}
  // -------------------------------------------------------- Use Effect -----------------------------------------
  useEffect(() => {
    getCompBuDeptData();
  }, [])

  const companyContent = <Form name="personal-info-details" className='modelform' >
  <Row>
      <Col md={12}>
          <FormGroup>
              <Label htmlFor="role_name">
                  Company Name*
              </Label>
              <Input id="companyName" name="companyName" type="text" value={companyName} placeholder='Company Name ' onChange={(e)=>setCompanyName(e.target.value)}/>
          </FormGroup>
      </Col>
      <Col md={12}>
          <FormGroup>
              <Label htmlFor="role_desc">
                  Description*
              </Label>
              <Input id="roleDesc" name="roleDesc" type="textarea" value={companyDesc} placeholder='Company Description' onChange={(e)=>setCompanyDesc(e.target.value)} />
          </FormGroup>
      </Col>

      <Col md={12}>
          <FormGroup>
              <Label htmlFor="role_desc">
                  Status:
              </Label>
              <div>
                  <div className="d-inline-block m-2"><input type="radio" id="isActive" name="status" value='1' checked={isActive === "1" ? true : false} onChange={(e)=>setIsActive("1")} /> Active</div>
                  <div className="d-inline-block"><input type="radio" id="isInactive" name="status" value='0' checked={isActive === "1" ? false : true} onChange={(e)=>setIsActive("0")} /> Inactive</div>
              </div>
          </FormGroup>
      </Col>
   
  </Row>
</Form>
  return (
    loading ? (
        <div className="loader">
        <InfinitySpin width="200" color="#D81159" />
      </div>
      ) :
    (  <>
    <TopHeader
    breadCrumb = {
      <>
          <li className="nav-item"><a onClick={() => navigate("/home")} className="nav-link">Home <BsChevronRight /></a></li> 
          <li className="nav-item"><span>Add Company</span></li>
      </>
    }/>
         <SubHeader 
                SubHeaderTitle="Add Company"
                openSidebar={modal} 
                isFilter={isFilter}
                handleClose={handleClose}
                toggleModal={toggleModal}
                toggleFilter={toggleFilter}
                handleSubmit={postCompanyData} 
                titleButton={`${updateId ?'Edit':'Add'} Company`}
                showButton={((rolexModuleData?.find((data) => pathname === data?.description && data?.create === 1)) || roles?.find((data) => data?.role_id === 1001)) ? true : false} 
                AddUserContent={companyContent} 
            />
            <div className='company-wrap'>
            <div className='managerole-wrap contentInnerWrap'>
                <div className='managerole'>
                    <div className='manage-table'>
                            <Table striped responsive>
                                <thead>
                                    <tr>
                                        <th style={{ width: "3" }}>Company ID</th>
                                        <th>Company Name</th>
                                        <th> Description</th>
                                        <th>Status</th>
                                        <th>Created on</th>
                                        <th>Updated on</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {companyData?.length > 0 ? companyData?.map((item)=>(
                                        <tr>
                                        <th scope="row">{item?.company_id}</th>
                                        <td>{item?.company_name}</td>
                                        <td>{item?.company_description}</td>
                                        <td>{item?.isActive === "1" ? "Active" : "Inactive"}</td>
                                        <td>{new Date(item?.createdDate?.split('T')?.[0])?.toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric', year: 'numeric' })}</td>
                                        <td>{new Date(item?.updatedDate?.split('T')?.[0])?.toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric', year: 'numeric' })}</td>
                                        <td>
                                            {((rolexModuleData?.find((data) => pathname === data?.description && data?.update === 1)) || roles?.find((data) => data?.role_id === 1001)) ? <NavLink className='edit'  onClick={() => companyUpt(item?.company_id)}><FaEdit /></NavLink> :  '-' }
                                        </td>
                                    </tr>
                                    )) : <div className='emptydata'><p>There is no company data!</p></div>}
                                </tbody>
                            </Table>
                    </div>
                </div>
            </div>
            </div>
        </>)
  )
}

export default AddCompany